'use client';

import { useEffect, useState } from 'react';
import { TMediaQuery } from '@/types';

type TStatus = 'isLoading' | 'mobile' | 'desktop';

interface IState {
  mediaQuery?: TMediaQuery;
  isLoading: boolean;
}

const VARIABLES = {
  initState: {
    isLoading: true
  } as IState
};

const useScreenSize = () => {

  const [state, setState] = useState<IState>(VARIABLES.initState);

  const isMobile = !['lg', 'xl', '2xl'].includes(state.mediaQuery as any);

  const status = (
    state.isLoading
      ? 'isLoading'
      : isMobile
        ? 'mobile'
        : 'desktop'
  ) as TStatus;

  const handleOnResize = () => {
    const mediaQuery = (
      window.innerWidth < 640
        ? 'xs'
        : window.innerWidth <= 640 && window.innerWidth < 768
          ? 'sm'
          : window.innerWidth <= 768 && window.innerWidth < 1024
            ? 'md'
            : window.innerWidth <= 1024 && window.innerWidth < 1280
              ? 'lg'
              : window.innerWidth <= 1280 && window.innerWidth < 1536
                ? 'xl'
                : '2xl'
    );

    setState(l => ({ ...l, mediaQuery, isLoading: false }));
  };

  useEffect(
    () => {
      handleOnResize();
      window.addEventListener('resize', handleOnResize);

      return () => {
        window.removeEventListener('resize', handleOnResize);
      };
    },
    []
  );

  return ({
    mediaQuery: state.mediaQuery,
    isLoading: state.isLoading,
    isMobile,
    status
  });

};

export default useScreenSize;
